import { HttpInterceptorFn, HttpErrorResponse, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { StorageService } from '@services/core/storage.service';
import { UserService } from '@services/core/user.service';
import { catchError, throwError } from 'rxjs';
import { hasToken, isSessionCall, isUnauthorized } from './auth-interceptor.utils';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(MicrosoftAuthService)
  const storageService = inject(StorageService)
  const userService = inject(UserService)
  const router = inject(Router)
  const token = authService.token();
  if (!hasToken(token)) return next(req);
  return handleWithToken(req, next, token, authService, storageService, userService, router)
};

function handleWithToken(req: HttpRequest<unknown>, next: HttpHandlerFn, token: unknown, auth: MicrosoftAuthService, storage: StorageService, users: UserService, router: Router) {
  const cloned = buildClone(req, token);
  return next(cloned).pipe(
    catchError((err: HttpErrorResponse) => handleFailure(req, err, auth, storage, users, router))
  )
}

function buildClone(req: HttpRequest<unknown>, token: unknown) {
  return req.clone(buildHeaders(token));
}

function buildHeaders(token: unknown) {
  return { setHeaders: { Authorization: `${token}` } };
}

function handleFailure(req: HttpRequest<unknown>, err: HttpErrorResponse, auth: MicrosoftAuthService, storage: StorageService, users: UserService, router: Router) {
  if (shouldClear(err, req)) clearSession(auth, storage, users, router);
  return throwError(() => err)
}

// Limpia solo ante 401 de llamadas con sesión válida, nunca de decrypt-token.
function shouldClear(err: HttpErrorResponse, req: HttpRequest<unknown>): boolean {
  if (!isUnauthorized(err)) return false;
  return !isSessionCall(req.url);
}

function clearSession(auth: MicrosoftAuthService, storage: StorageService, users: UserService, router: Router) {
  storage.clearStorage()
  auth.isLoggedSignal.set(false)
  clearToken(auth, users)
  router.navigateByUrl('/')
}

function clearToken(auth: MicrosoftAuthService, users: UserService) {
  auth.token.set(null)
  users.resetState()
}
